import React from "react";
import {Box, Text} from "@unibuddy/patron";

import WarningIconWithOutline from "shared/Experimental/Icons/WarningIconWithOutline";

export function ChatInterventionBanner() {
    return (
        <Box display="flex" bgColor="#dfedf7" tabIndex={0}>
            <Box padding="medium" display="flex" gap="medium" alignItems="center">
                <Box flexShrink={0}>
                    <WarningIconWithOutline />
                </Box>
                <Text weight="bold">
                    You’ve been contacted by a member of the university administrative staff in this
                    conversation! Your personal details will not be shared.
                </Text>
            </Box>
        </Box>
    );
}
